import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { Box } from "@mui/material";
import maquina from "assets/images/equipamentos/maquin.png";

export default function EquipamentosMaquinas() {
  const navigate = useNavigate(); // Hook para navegação
  const [position, setPosition] = useState({ x: 50, y: 50 });

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setPosition({ x, y });
  };

  // Função para navegar para /estrutura-industrial
  const handleSaibaMaisClick = () => {
    navigate("/estrutura-industrial");
  };

  return (
    <MKBox
      component="section"
      sx={{

        py: { xs: 8, md: 10 },
        position: "relative",
        overflow: "hidden",
        "&:before": {
          content: '""',
          position: "absolute",
          top: 0,
          right: 0,
          width: "40%",
          height: "100%",
          background: "linear-gradient(135deg, rgba(0, 70, 35, 0.03) 0%, transparent 100%)",
          zIndex: 0,
        }
      }}
    >
      <Container sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={6} alignItems="center">
          {/* Coluna de Texto */}
          <Grid item xs={12} md={6}>
            <MKTypography
              variant="h2"
              color="dark"
              fontWeight="bold"
              mb={3}
              sx={{
                fontFamily: "'Martian Mono', monospace",
                letterSpacing: { xs: 1, md: 2 },
                lineHeight: 1.1,
                fontSize: {
                  xs: "1.5rem",
                  md: "2rem",
                },
                position: "relative",
                "&:after": {
                  content: '""',
                  position: "absolute",
                  bottom: -12,
                  left: 0,
                  width: 60,
                  height: 4,
                  backgroundColor: "#00361F",
                  borderRadius: 2
                }
              }}
            >
              EQUIPAMENTOS
              <br />
              <Box
                component="span"
                sx={{
                  color: "#00361F",
                  display: "block",
                  mt: 1
                }}
              >
                & MÁQUINAS
              </Box>
            </MKTypography>

            <Grid container spacing={4} sx={{ mt: 1 }}>
              {/* Bloco esquerdo */}
              <Grid item xs={12} md={6}>
                <MKTypography
                  variant="body1"
                  color="text.secondary"
                  sx={{
                    textAlign: "justify",
                    lineHeight: 1.7,
                    fontFamily: "'Lato', sans-serif",
                    fontSize: "1rem",
                    mb: 3
                  }}
                >
                  Investimos na <Box component="strong" sx={{ color: "#00361F", fontWeight: 600 }}>aquisição de máquinas</Box> e equipamentos para
                  aprimorar constantemente a <Box component="strong" sx={{ color: "#00361F", fontWeight: 600 }}>qualidade de nossos produtos</Box>, sempre focando
                  na <Box component="strong" sx={{ color: "#00361F", fontWeight: 600 }}>otimização de processos</Box> e na <Box component="strong" sx={{ color: "#00361F", fontWeight: 600 }}>redução de custos</Box> para nossos clientes.
                </MKTypography>
                {/* Botão com navegação */}
                <MKButton
                  variant="contained"
                  color="dark"
                  onClick={handleSaibaMaisClick} // Adicionar o evento de clique
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: "8px",
                    backgroundColor: "#00361F",
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    alignSelf: { xs: "center", md: "flex-start" },
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 14px rgba(0, 54, 31, 0.25)",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 20px rgba(0, 54, 31, 0.35)",
                      backgroundColor: "#002E18",
                    },
                  }}
                >
                  SAIBA MAIS
                </MKButton>
              </Grid>

              {/* Bloco direito com linha */}
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  position: "relative"
                }}
              >
                <Box
                  sx={{
                    borderLeft: { xs: "none", md: "2px solid rgba(0, 70, 35, 0.2)" },
                    pl: { xs: 0, md: 4 },
                    mb: 4,
                    position: "relative",
                    "&:before": {
                      content: { xs: '""', md: '"·"' },
                      position: "absolute",
                      left: -10,
                      top: 0,
                      color: "#00361F",
                      fontSize: "2rem",
                      fontWeight: "bold"
                    }
                  }}
                >
                  <MKTypography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      textAlign: "justify",
                      lineHeight: 1.7,
                      fontFamily: "'Lato', sans-serif",
                      fontSize: "1rem"
                    }}
                  >
                    <Box component="strong" sx={{ color: "#00361F", fontWeight: 600 }}>Maquinários de primeira linha</Box> e{" "}
                    <Box component="strong" sx={{ color: "#00361F", fontWeight: 600 }}>profissionais altamente capacitados</Box> são a base
                    para que a Ramlis Machine ofereça{" "}
                    <Box component="strong" sx={{ color: "#00361F", fontWeight: 600 }}>o melhor em moldes e estampos</Box>, garantindo
                    excelência e confiabilidade em cada projeto.
                  </MKTypography>
                </Box>


              </Grid>
            </Grid>
          </Grid>

          {/* Coluna de Imagem com pan-zoom */}
          <Grid item xs={12} md={6}>
            <MKBox
              sx={{
                p: 3,
                borderRadius: "16px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                bgcolor: "white",
                border: "1px solid rgba(0, 0, 0, 0.04)",
                textAlign: "center",
                overflow: "hidden",
                cursor: "zoom-in",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 12px 40px rgba(0, 0, 0, 0.12)",
                  transform: "translateY(-4px)"
                }
              }}
              onMouseMove={handleMouseMove}
            >
              <MKBox
                component="img"
                src={maquina}
                alt="Equipamentos Ramlis Machine"
                sx={{
                  width: "100%",
                  maxWidth: 500,
                  mx: "auto",
                  display: "block",
                  borderRadius: "12px",
                  transition: "transform 0.2s ease",
                  transformOrigin: `${position.x}% ${position.y}%`,
                  "&:hover": {
                    transform: "scale(2.2)",
                  },
                }}
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}